import React from 'react';
import { useTranslation } from 'react-i18next';

const ErrorPage = () => {
  const { t } = useTranslation();
  return (
    <div className="row u-navbar-padding">
      <div className="column">
        <h1>{t('errorPage.title')}</h1>
        <p>{t('errorPage.message1')}</p>
        <p>{t('errorPage.message2')}</p>
        <p>{t('errorPage.message3')}</p>
      </div>
    </div>
  );
};

export default ErrorPage;
